import { Content, type DialogProps, Overlay, Portal, Root } from '@radix-ui/react-dialog';
import classNames from 'classnames';
import { type ReactNode, useCallback } from 'react';

import styles from './Modal.module.scss';

export interface Props extends Omit<DialogProps, 'onOpenChange'> {
    children: ReactNode;
    fullScreen?: boolean;
    className?: string;
    onClose?: () => void;
    maxWidth?: number;
}

export function Modal({
    maxWidth = 640,
    children,
    className,
    fullScreen,
    onClose,
    open,
    ...props
}: Props) {
    const handleOpenChange = useCallback(
        (isOpen: boolean) => {
            if (!isOpen) {
                onClose?.();
            }
        },
        [onClose],
    );

    return (
        <Root onOpenChange={handleOpenChange} open={open} {...props}>
            <Portal>
                <Overlay className={styles.backdrop} />
                <Content
                    className={classNames(styles.content, {
                        [styles.fullscreen]: fullScreen,
                    })}
                >
                    <div
                        style={{ maxWidth }}
                        className={classNames(styles.innerContent, {
                            [styles.fullscreen]: fullScreen,
                        })}
                    >
                        <div className={classNames(className, styles.modal)}>{children}</div>
                    </div>
                </Content>
            </Portal>
        </Root>
    );
}
